export default __webpack_public_path__ + "static/media/wall-mount-pids.86d2c06d.jpg";